import { BrowserRouter, Switch, Route } from "react-router-dom";

import { Home, ContactUs, Artist } from "./pages";
import React from "react";
import ScrollToTop from "./ScrollToTop";
export default function Routes() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/artist" component={Artist} />
        <Route exact path="/contact" component={ContactUs} />
      </Switch>
    </BrowserRouter>
  );
}



// WEBPACK FOOTER //
// ./src/routes.jsx